import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getContractorProfileById = createAsyncThunk(
  "contractorProfileDetail/getContractorProfileById",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/contractor/get_by_id`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const contractorProfileSlice = createSlice({
  name: "contractorProfileDetail",
  initialState: {
    loading: false,
    contractorProfileDetailData: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getContractorProfileById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getContractorProfileById.fulfilled, (state, action) => {
        state.loading = false;
        state.contractorProfileDetailData = action.payload;
      })
      .addCase(getContractorProfileById.rejected, (state, action) => {
        state.loading = false;
        state.contractorProfileDetailData = action.payload;
        state.error = action.payload;
      });
  },
});

export default contractorProfileSlice.reducer;
